import React from 'react';
import Icon from '../../../components/AppIcon';

const SatisfactionRating = ({ ratings }) => {
  const totalResponses = ratings?.reduce((sum, rating) => sum + rating?.count, 0);

  return (
    <div className="bg-card rounded-lg p-6 shadow-brand">
      <h3 className="text-lg font-semibold text-foreground mb-6">User Satisfaction Ratings</h3>
      <div className="space-y-4">
        {ratings?.map((rating, index) => {
          const percentage = (rating?.count / totalResponses) * 100;
          return (
            <div key={index} className="space-y-2">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="flex">
                    {[...Array(5)]?.map((_, i) => (
                      <Icon
                        key={i}
                        name={i < rating?.stars ? "Star" : "Star"}
                        size={16}
                        className={i < rating?.stars ? "text-warning fill-warning" : "text-muted"}
                      />
                    ))}
                  </div>
                  <span className="text-sm font-medium text-foreground">
                    {rating?.stars} {rating?.stars === 1 ? 'Star' : 'Stars'}
                  </span>
                </div>
                <span className="text-sm text-muted-foreground">
                  {rating?.count} ({percentage?.toFixed(1)}%)
                </span>
              </div>
              <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
                <div 
                  className="h-full bg-warning rounded-full transition-all duration-500"
                  style={{ width: `${percentage}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium text-foreground">Average Rating</span>
          <div className="flex items-center gap-2">
            <Icon name="Star" size={20} className="text-warning fill-warning" />
            <span className="text-2xl font-bold text-foreground">
              {(ratings?.reduce((sum, r) => sum + (r?.stars * r?.count), 0) / totalResponses)?.toFixed(1)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SatisfactionRating;